// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// External Plugins
import VueResource from 'vue-resource'
import VeeValidate from 'vee-validate'
import VueMoment from 'vue-moment'
import VueHighlightJS from 'vue-highlightjs'
import vClickOutside from 'v-click-outside'
import VueAwesomeSwiper from 'vue-awesome-swiper'

// Local Plugins
import PrettyBytes from 'plugins/prettybytes'
import Package from 'plugins/package'
import Sentry from 'plugins/sentry'
import Analytics from 'plugins/analytics'

// Styles

import 'swiper/dist/css/swiper.css'

Vue.use(VueMoment) // Dates Formating
Vue.use(VueResource) // HTTP Requests
Vue.use(VeeValidate) // Form Validations
Vue.use(VueHighlightJS) // Code Highlight
Vue.use(vClickOutside) // Handles Outslide Clicks
Vue.use(PrettyBytes) // Formats Bytes Output
Vue.use(Package) // Injects Package Data in $package
Vue.use(Analytics, process.env) // Google Analytics
Vue.use(Sentry, process.env) // Sentry Errorr Reporting
Vue.use(VueAwesomeSwiper) // Swipper

Vue.http.options.root = '/api'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js